import DeliveryTimeWidget from "./components/DeliveryTimeWidget.vue";

export function createApp() {
    Vue.component( "delivery-time-widget", DeliveryTimeWidget );
}
